module.exports = __webpack_public_path__ + "static/media/heart2.e24dbed0.svg";